import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function CollectIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9997 3.62837C11.9997 3.62837 13.333 2.95937 14.1603 3.63672C14.295 3.74563 14.4631 3.96121 14.5369 4.11969C14.6663 4.39757 14.6663 4.66703 14.6663 5.20594V12.5452C14.6663 13.2162 13.973 13.6771 13.333 13.5273C12.7199 13.3838 12.0436 13.3042 11.333 13.3042C10.0549 13.3042 8.88801 13.5615 7.99967 13.9856C7.11134 14.4096 5.94439 14.6669 4.66634 14.6669C3.95573 14.6669 3.27947 14.5874 2.66634 14.4438C2.27221 14.3516 2.07513 14.3054 1.83899 14.1145C1.70431 14.0056 1.53623 13.79 1.46242 13.6315C1.33301 13.3536 1.33301 13.0842 1.33301 12.5452V5.20594C1.33301 4.53495 2.02636 4.07409 2.66634 4.2239C3.18283 4.3448 3.74412 4.4203 4.33301 4.44109"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M9.66634 9.00016C9.66634 9.92063 8.92014 10.6668 7.99967 10.6668C7.07921 10.6668 6.33301 9.92063 6.33301 9.00016C6.33301 8.0797 7.07921 7.3335 7.99967 7.3335C8.92014 7.3335 9.66634 8.0797 9.66634 9.00016Z"
        stroke="currentColor"
      />
      <path
        d="M3.66699 9.6665V9.6725"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.333 8.32812V8.33412"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33301 3.66683C6.66069 4.00396 7.53287 5.3335 7.99967 5.3335M7.99967 5.3335C8.46647 5.3335 9.33867 4.00396 9.66634 3.66683M7.99967 5.3335V1.3335"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
